module.exports = __webpack_public_path__ + "static/img/Main beam 4.0m (hollow 50x50x4.0m).3a7d1ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Main beam 4.0m (hollow 50x50x4.0m).jpg
// module id = 88
// module chunks = 1